// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--8fa1e";
export var carousel = "styles-module--carousel--df828";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var tileGrid = "styles-module--tileGrid--a5747";
export var title = "styles-module--title--29697";